import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';

const ShowAllModal = ({
    modalState,
    onClose,
    onHide,
    renderContent,
    renderFn,
    searchValue,
    show,
    title,
    count
}) => {
    const { t } = useTranslation('common');

    const isVisible = show ?? (modalState ? modalState.showAll : false);
    if (!isVisible) return null;

    const modalTitle = title || (modalState ? modalState.title : '');
    const modalCount = count ?? (modalState ? modalState.count : 0);
    const closeHandler = onHide || onClose || (() => {});
    const renderFunction = renderFn || (renderContent ? () => renderContent(modalState ? modalState.type : '', 1000) : null);

    const note = (t("Pages.Search.Note") || "تم إيجاد __COUNT__ نتيجة للبحث عن: __KEY__")
        .replace("__COUNT__", `<span class="badge badge-primary px-2 py-1 mx-1 font-weight-bold" style="font-size:0.95rem;">${modalCount}</span>`)
        .replace("__KEY__", `<span class="text-primary font-weight-bold">"${searchValue || ''}"</span>`);

    return (
        <Modal
            size="lg"
            show={true}
            onHide={closeHandler}
            keyboard={false}
            enforceFocus={false}
            centered
            dialogClassName="search-show-all-modal"
        >
            <Modal.Header closeButton className="border-0 pb-0 pt-4 px-4 bg-white" style={{ borderRadius: '20px 20px 0 0' }}>
                <Modal.Title className="w-100">
                    <div className="d-flex align-items-center">
                        <span className="h4 mb-0 font-weight-bold text-dark" dangerouslySetInnerHTML={{ __html: modalTitle }}></span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4 bg-light">
                <div className="mb-3 p-3 bg-white rounded-lg shadow-sm border-right border-primary" style={{ borderRightWidth: '4px' }}>
                    <div className="text-dark font-size-h6 mb-0" dangerouslySetInnerHTML={{ __html: note }}></div>
                </div>

                <div className="modal-results-container" style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '5px' }}>
                    {renderFunction ? renderFunction() : null}
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-2 pb-4 px-4 bg-light" style={{ borderRadius: '0 0 20px 20px' }}>
                <button
                    className="btn btn-secondary px-4 py-2 rounded-pill font-weight-bold w-auto"
                    onClick={closeHandler}
                >
                    <i className="fas fa-times ml-2"></i>
                    {t('Close', 'إغلاق')}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ShowAllModal;
